import { render, staticRenderFns } from "./WelcomeDialog.vue?vue&type=template&id=12d359b5&scoped=true&"
import script from "./WelcomeDialog.vue?vue&type=script&lang=js&"
export * from "./WelcomeDialog.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeDialog.vue?vue&type=style&index=0&id=12d359b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d359b5",
  null
  
)

export default component.exports